import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useCreate from "../../useCreate";
import toast from "react-hot-toast";

const useUpdateAttributeValue = ({ reset }) => {
  const { attributeValueId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setDataToServer } = useCreate({
    url: "product/attribute-value/update",
    refreshUrl: "product/attribute-value/list",
    onSuccess: () => {
      if (searchParams.get("mode") === "edit") {
        navigate(`/catalog/variants/attribute-values`);
      } else {
        reset?.();
      }
      toast.success("Attribute Value Updated Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
  });

  const handleSubmit = (data) => {
    let finalFormData;
    if (attributeValueId) {
      finalFormData = {
        ...data,
        attribute_value_id: attributeValueId,
      };
    } else {
      finalFormData = data;
    }
    setDataToServer.mutate(finalFormData);
  };

  return { handleSubmit };
};

export default useUpdateAttributeValue;
